import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const sContent = {
    id: 'sContent',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'sContent',
            title: 'S Content',
            type: 'item',
            url: '/s-content',
            icon: ContentPasteSearchIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default sContent;
